import styled from "styled-components";
import { leftColumnWidth } from "./../../../../constants";
import { TopbarProps } from "./types";

const resetBtnStyles = `
  background: none;
  outline: none;
  border: none;
  font-size: 100%;
  line-height: 1.15
  margin: 0
`;

export const Wrapper = styled.div<TopbarProps>`
  width: calc(100vw - 80px - ${leftColumnWidth}px);
  position: sticky;
  top: 0;
  left: ${leftColumnWidth}px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
  height: ${({ theme }) => theme.navHeight};
  padding: 0.625rem 1rem;
  padding-right: 1.7rem;
  background-color: ${({ theme }) => theme.colors.background};
  z-index: 3;

  @media (max-width: 890px) {
    justify-content: center;
    flex-direction: column-reverse;
    left: calc(44px + ${leftColumnWidth}px);
    height: calc(${({ theme }) => theme.navHeight} + 47px);
  }
`;

export const Title = styled.h1`
  font-size: 2rem;
  color: ${() => '#616161'};
  font-weight: 500;

  @media (max-width: 890px) {
    display: none;
  }
`

export const NavigationWrapper = styled.div`
  display: flex;
  gap: 1.875rem;
  
  @media (max-width: 890px) {
    margin: auto;
    margin-left: auto;
  }
`;

export const NavBtn = styled.button`
  ${resetBtnStyles};
  display: flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 1rem;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.textPrimary};
  :not(:disabled) {
    cursor: pointer;
  }
`;

export const Today = styled.button`
  ${resetBtnStyles};
  display:flex;
  position: relative;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.5rem;
  color: ${({ theme }) => theme.colors.textPrimary};

  &::before,
  &::after {
    content: "";
    position: absolute;
    width: 1px;
    height: 100%;
    background-color: ${({ theme }) => theme.colors.textPrimary};
  }
  &::before {
    left: -1.125rem;
  }
  &::after {
    right: -1.125rem;
  }
`;

export const Zoom = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
  font-size: 0.875rem;
  color: ${({ theme }) => theme.colors.textPrimary};
`;

export const Filters = styled.div`
  display: flex;
`;

export const OptionsContainer = styled.div`
  display: flex;
  align-items: "center";
  gap: 1.25rem;
`;
